<template lang="pug">
  div(v-if="isDeliveryHouse" :class="customClasses ? '' : 'mt-ds-sm lg:mt-ds-md'")
    VeeField(
      name="deliveryPropertyType"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="getDeliveryPropertyType"
        @input="handlePropertyType"
        :options="getPropertyTypesHouse"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.select_property_type')"
        :custom-classes="!errors.length && isDeliveryFlat ? '!rounded-b-none ' + customClasses : customClasses"
        :initial-open="true"
        :sub-menu="true"
        indicator
        qa-tag="sel_delivery_prop_type_house"
      )
      VeeErrorMessage(name="deliveryPropertyType")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.property_type_to') }}
  div(v-else-if="isDeliveryFlat" :class="customClasses ? '' : 'mt-ds-sm lg:mt-ds-md'")
    VeeField(
      name="deliveryPropertyType"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="getDeliveryPropertyType"
        @input="handlePropertyType"
        :options="getPropertyTypesFlat"
        option-text="name"
        option-value="value"
        :custom-classes="!errors.length && !propertyFloorHidden && requiresDeliveryFloor ? '!rounded-b-none ' + customClasses : customClasses"
        :placeholder="$t('location_form.select_property_type')"
        :initial-open="true"
        :sub-menu="true"
        indicator
        qa-tag="sel_delivery_prop_type_flat"
      )
      VeeErrorMessage(name="deliveryPropertyType")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.property_type_to') }}

      SelRefined(
        v-if="!propertyFloorHidden && requiresDeliveryFloor"
        :value="getDeliveryFloor"
        @input="handleDeliveryFloor"
        :class="!errors.length ? '' : 'mt-ds-sm lg:mt-ds-md'"
        :custom-classes="!errors.length ? '!rounded-t-none !border-t-0 ' + floorStylingToConnectLiftAvailable  : floorStylingToConnectLiftAvailable"
        :options="getFloors"
        option-text="name"
        option-value="value"
        indicator
        qa-tag="sel_delivery_floor")

    VeeField(
      v-if="requiresDeliveryFloor && !isDeliveryGroundFloor && isFrenchLocale"
      name="deliveryLiftSize"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="liftSizeValue"
        @input="handleLiftSize"
        custom-classes="!rounded-t-none !border-t-0"
        :options="getLiftSizeOptions"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.lift_size')"
        indicator
        qa-tag="sel_delivery_lift_size")
      VeeErrorMessage(name="deliveryLiftSize")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.lift_size') }}

    SelRefined(
      v-if="requiresDeliveryFloor && !isDeliveryGroundFloor && !isFrenchLocale"
      :value="liftAvailable"
      @input="handleLiftAvailable"
      :custom-classes="'!rounded-t-none !border-t-0'"
      :options="getLiftAvailableOptions"
      option-text="name"
      option-value="value"
      indicator
      qa-tag="sel_delivery_lift")

  div(v-else-if="!propertyTypeHidden" :class="customClasses ? '' : 'mt-ds-sm lg:mt-ds-md'")
    VeeField(
      name="deliveryPropertyType"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="getDeliveryPropertyType"
        @input="handlePropertyType"
        :custom-classes="!errors.length && !propertyFloorHidden && requiresDeliveryFloor ? '!rounded-b-none ' + customClasses : customClasses"
        :options="getPropertyTypesMain"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.select_property_type')"
        :initial-open="getDeliveryPropertyType === ''"
        indicator
        qa-tag="sel_delivery_prop_type")
      VeeErrorMessage(name="deliveryPropertyType")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.property_type_to') }}

      SelRefined(
        v-if="!propertyFloorHidden && requiresDeliveryFloor"
        :value="getDeliveryFloor"
        @input="handleDeliveryFloor"
        :class="!errors.length ? '' : 'mt-ds-sm lg:mt-ds-md'"
        :custom-classes="!errors.length ? '!rounded-t-none !border-t-0 ' + floorStylingToConnectLiftAvailable  : floorStylingToConnectLiftAvailable"
        :options="getFloors"
        option-text="name"
        option-value="value"
        indicator
        qa-tag="sel_delivery_floor")

    VeeField(
      v-if="requiresDeliveryFloor && !isDeliveryGroundFloor && isFrenchLocale"
      name="deliveryLiftSize"
      v-slot="{ field, errors }"
    )
      SelRefined(
        v-bind="field"
        :value="liftSizeValue"
        @input="handleLiftSize"
        custom-classes="!rounded-t-none !border-t-0"
        :options="getLiftSizeOptions"
        option-text="name"
        option-value="value"
        :placeholder="$t('location_form.lift_size')"
        indicator
        qa-tag="sel_delivery_lift_size")
      VeeErrorMessage(name="deliveryLiftSize")
        TextInputError(class="my-ds-sm")
          | {{ $t('location_form.error.lift_size') }}

    SelRefined(
      v-if="requiresDeliveryFloor && !isDeliveryGroundFloor && !isFrenchLocale"
      :value="liftAvailable"
      @input="handleLiftAvailable"
      :custom-classes="'!rounded-t-none !border-t-0'"
      :options="getLiftAvailableOptions"
      option-text="name"
      option-value="value"
      indicator
      qa-tag="sel_delivery_lift")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { mapGetters, mapActions } from "vuex"
import { getAttributes } from "~/utils/block"
import {
  SET_DELIVERY_FLOOR,
  SET_DELIVERY_PROPERTY_TYPE,
  SET_LISTING,
  SET_DELIVERY_LIFT_AVAILABLE,
  SET_DELIVERY_LIFT_TYPE,
  GET_DELIVERY_FLOOR,
  GET_DELIVERY_LIFT_AVAILABLE,
  GET_DELIVERY_LIFT_TYPE,
  GET_DELIVERY_PROPERTY_TYPE,
  state as InitialListing
} from "~/store/listing"
import { isFlat, isHouse, requiresFloor } from "~/services/public/Listing"
import {
  FLOOR_GROUND,
  LIFT_AVAILABLE,
  LIFT_UNAVAILABLE,
  LIFT_TYPE_NO_LIFT,
  LIFT_TYPE_STANDARD,
  LIFT_TYPE_LARGE,
  LIFT_TYPE_EXTRA_LARGE
} from "~/constants/listing"
import {
  GET_FLOORS,
  GET_PROPERTY_TYPES,
  GET_PROPERTY_TYPES_MAIN,
  GET_PROPERTY_TYPES_FLAT,
  GET_PROPERTY_TYPES_HOUSE
} from "~/store/property"
import { swapFirstTwoElements } from "~/scripts/useful-functions"
import { LOCALE } from "~/constants/locale"


export default defineComponent({
  name: "PropertyDeliveryInput",

  props: {
    propertyTypeHidden: {
      type: Boolean
    },
    propertyFloorHidden: {
      type: Boolean
    },
    block: {
      type: Object,
      required: true
    },
    virgin: {
      type: Boolean
    },
    lazy: {
      type: Boolean,
      default: true
    },
    customClasses: {
      type: String,
      default: ""
    }
  },

  computed: {
    ...mapGetters("listing", {
      getDeliveryFloor: GET_DELIVERY_FLOOR,
      getDeliveryLiftAvailable: GET_DELIVERY_LIFT_AVAILABLE,
      getDeliveryLiftType: GET_DELIVERY_LIFT_TYPE,
      getDeliveryPropertyType: GET_DELIVERY_PROPERTY_TYPE
    }),
    ...mapGetters("property", {
      getStorePropertyTypes: GET_PROPERTY_TYPES,
      getStorePropertyTypesMain: GET_PROPERTY_TYPES_MAIN,
      getPropertyTypesHouse: GET_PROPERTY_TYPES_HOUSE,
      getPropertyTypesFlat: GET_PROPERTY_TYPES_FLAT,
      getFloors: GET_FLOORS
    }),

    getPropertyTypesMain(): any[] {
      if (!this.getStorePropertyTypesMain) return []

      const propertyTypesToShow = this.getStorePropertyTypesMain.filter(type => !type.hidden)

      if (this.$i18n.locale === LOCALE.ES) {
        return swapFirstTwoElements(propertyTypesToShow)
      }
      return propertyTypesToShow
    },

    attributes(): Record<string, any> | null {
      return this.virgin ? null : getAttributes(this.block)
    },

    liftAvailable(): number {
      if (this.getDeliveryLiftAvailable === null) {
        this.setLiftAvailable(LIFT_AVAILABLE)
        return LIFT_AVAILABLE
      }
      return this.getDeliveryLiftAvailable
    },

    getLiftAvailableOptions(): LiftOption[] {
      return [
        {
          name: this.$t("location_form.lift_available") as string,
          value: LIFT_AVAILABLE
        },
        {
          name: this.$t("location_form.lift_not_available") as string,
          value: LIFT_UNAVAILABLE
        }
      ]
    },
    getLiftSizeOptions(): LiftSizeOption[] {
      return [
        {
          name: this.$t("location_form.lift_no_lift") as string,
          value: LIFT_TYPE_NO_LIFT
        },
        {
          name: this.$t("location_form.lift_small") as string,
          value: LIFT_TYPE_STANDARD
        },
        {
          name: this.$t("location_form.lift_medium") as string,
          value: LIFT_TYPE_LARGE
        },
        {
          name: this.$t("location_form.lift_large") as string,
          value: LIFT_TYPE_EXTRA_LARGE
        }
      ]
    },
    liftSizeValue(): string | null {
      if (this.getDeliveryLiftAvailable === LIFT_UNAVAILABLE) {
        return LIFT_TYPE_NO_LIFT
      }
      if (this.getDeliveryLiftAvailable === LIFT_AVAILABLE && this.getDeliveryLiftType) {
        return this.getDeliveryLiftType
      }
      return null
    },
    isFrenchLocale(): boolean {
      return this.$i18n.locale === LOCALE.FR
    },
    isDeliveryGroundFloor(): boolean {
      return this.getDeliveryFloor === FLOOR_GROUND
    },
    isDeliveryHouse(): boolean {
      return isHouse(this.getDeliveryPropertyType)
    },
    isDeliveryFlat(): boolean {
      return isFlat(this.getDeliveryPropertyType)
    },
    requiresDeliveryFloor(): boolean {
      return requiresFloor(this.getDeliveryPropertyType, this.propertyTypeHidden, this.propertyFloorHidden, this.getStorePropertyTypes)
    },
    floorStylingToConnectLiftAvailable(): string {
      return !this.isDeliveryGroundFloor ? '!rounded-b-none' : ''
    }
  },

  created() {
    this.setListing(InitialListing())
  },

  methods: {
    ...mapActions("listing", {
      setDeliveryPropertyType: SET_DELIVERY_PROPERTY_TYPE,
      setDeliveryFloor: SET_DELIVERY_FLOOR,
      setLiftAvailable: SET_DELIVERY_LIFT_AVAILABLE,
      setLiftType: SET_DELIVERY_LIFT_TYPE,
      setListing: SET_LISTING
    }),

    handlePropertyType(value: string) {
      if (!isFlat(value) || this.getDeliveryFloor === FLOOR_GROUND) {
        this.setDeliveryFloor(FLOOR_GROUND)
        this.setLiftAvailable(null)
        this.setLiftType(null)
      }
      this.setDeliveryPropertyType(value)
    },

    handleDeliveryFloor(value: string | null): void {
      if (value === FLOOR_GROUND) {
        this.setLiftAvailable(null)
        this.setLiftType(null)
      }
      this.setDeliveryFloor(value)
    },

    handleLiftAvailable(value: string | null): void {
      this.setLiftAvailable(value)
    },

    handleLiftSize(value: string): void {
      if (value === LIFT_TYPE_NO_LIFT) {
        this.setLiftAvailable(LIFT_UNAVAILABLE)
        this.setLiftType(value)
      } else {
        this.setLiftAvailable(LIFT_AVAILABLE)
        this.setLiftType(value)
      }
    }
  }
})
</script>

<style lang="css" module></style>
